export default "__VITE_ASSET__Cnbu3SUi__";